export enum CurrencyId {
  BRL = "BRL",
  EUR = "EUR",
  GBP = "GBP",
  USD = "USD",
}
